<div class="app-container">
  <app-header
    [isSidebarCollapsed]="sidenav.isCollapsed"
    (toggleSidebar)="sidenav.toggleSidebar()"
  >
  </app-header>

  <!-- Main Content Area -->
  <div class="main-content">
    <!-- Sidebar -->
    <app-sidenav #sidenav></app-sidenav>

    <!-- Page Content -->
    <div class="page-content" [class.mobile]="sidenav.isMobile">
      <router-outlet></router-outlet>
    </div>
  </div>

  <!-- Mobile Overlay -->
  @if (sidenav.isMobile && !sidenav.isCollapsed) {
    <div class="mobile-overlay" (click)="sidenav.toggleSidebar()"></div>
  }
</div>
